// extracted by mini-css-extract-plugin
module.exports = {"button":"DocumentPrintButton-module__button___HWMof","inlineLink":"DocumentPrintButton-module__inlineLink___2lP2r"};